import { Inject, Injectable, WritableSignal, signal } from '@angular/core';
import { ApiSentrynelService } from 'src/app/core/services/api-sentrynel.service';
import { ASSIGNABLEROLES_USERROLE_ENDPOINT, ASSIGN_USERROLE_ENDPOINT, REVOKE_USERROLE_ENDPOINT, USERROLES_ENDPOINT, USERROLES_QUERY_SERVICE_INSTANCE } from './user-role.config';
import { IRuolo } from './models/ruoli.model';
import { AssignRoleDto } from './dto/assign-role.dto';
import { RevokeRoleDto } from './dto/revoke-role.dto';
import { IUserRole } from './models/user-role.model';
import { CrudService } from 'src/app/core/services/crud.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { QueryService } from 'src/app/core/services/query.service';
import { CrudSentrynelService } from 'src/app/core/services/crud-sentrynel.service';
import { QuerySentrynelService } from 'src/app/core/services/query-sentrynel.service';
import { UserDeleghe } from './models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService extends CrudSentrynelService<IUserRole> {

  assignableRoles: WritableSignal<IRuolo[]> = signal([]);

  constructor(
    @Inject(USERROLES_QUERY_SERVICE_INSTANCE) public readonly query: QuerySentrynelService<IUserRole>,
    @Inject(ApiSentrynelService) protected override readonly api: ApiSentrynelService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService
  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(USERROLES_ENDPOINT, api, snackbar);
  }

  assignRole(dto: AssignRoleDto) {
    return this.api.post(ASSIGN_USERROLE_ENDPOINT, dto);
  }

  revokeRole(dto: RevokeRoleDto) {
    return this.api.post(REVOKE_USERROLE_ENDPOINT, dto);
  }

  getAssignableRoles(userId: number | string) {
    return this.api.get<IRuolo[]>(`${ASSIGNABLEROLES_USERROLE_ENDPOINT}/${userId}`).subscribe((response) => {
      this.assignableRoles.set(response);
    });
  }



}
